import { render, staticRenderFns } from "./VehicleCurrentOwnership.vue?vue&type=template&id=2a7fc27c&scoped=true&"
import script from "./VehicleCurrentOwnership.vue?vue&type=script&lang=js&"
export * from "./VehicleCurrentOwnership.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCurrentOwnership.vue?vue&type=style&index=0&id=2a7fc27c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fc27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7fc27c')) {
      api.createRecord('2a7fc27c', component.options)
    } else {
      api.reload('2a7fc27c', component.options)
    }
    module.hot.accept("./VehicleCurrentOwnership.vue?vue&type=template&id=2a7fc27c&scoped=true&", function () {
      api.rerender('2a7fc27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleCurrentOwnership.vue"
export default component.exports